import { render, staticRenderFns } from "./Export.vue?vue&type=template&id=b2fc8732&scoped=true&"
import script from "./Export.vue?vue&type=script&lang=ts&"
export * from "./Export.vue?vue&type=script&lang=ts&"
import style0 from "./Export.vue?vue&type=style&index=0&id=b2fc8732&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fc8732",
  null
  
)

export default component.exports